import moment from 'moment'

export const sizeConversion = (fileByte) => {

    if (!fileByte) {
        return ''
    }
    let fileSizeByte = fileByte
    let fileSizeMsg = ''
    if (fileSizeByte < 1048576) fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + 'KB'
    else if (fileSizeByte == 1048576) fileSizeMsg = '1MB'
    else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824)
        fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + 'MB'
    else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = '1GB'
    else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776)
        fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
    else fileSizeMsg = '文件超过1TB'
    return fileSizeMsg
}

// 到期时间转换
export const expireConversion = (item) => {
    if (!item) return '永久有效';
    const t = item.valueOf() - moment().valueOf();
    if (moment().valueOf() > item.valueOf()) {
        return "已失效"
    } else if (t < 1000 * 60 * 60) {
        return moment.duration(t).minutes() + '分钟后到期'
    } else if (t < 1000 * 60 * 60 * 24) {
        return moment.duration(t).hours() + '小时后到期'
    } else if (t < 1000 * 60 * 60 * 24 * 7) {
        return moment.duration(t).days() + '天后到期'
    } else {
        return item.format("YYYY-MM-DD HH:mm");
    }
}

// 文件图标准换
export const getFileIcon = (item) => {
    let fileType = item;
    if (fileType == 'png' || fileType == 'bmp' || fileType == 'jpeg' || fileType == 'jpg' || fileType == 'gif' || fileType == 'tiff') {
        fileType = 'jpg'
    }
    if (fileType == 'wav' || fileType == 'mp3' || fileType == 'au' || fileType == 'aiff' || fileType == 'ram') {
        fileType = 'mp3'
    }
    if (fileType == 'mp4' || fileType == 'mov' || fileType == 'rmvb' || fileType == 'rm' || fileType == 'flv' ||
        fileType == '3gp' || fileType == 'avi' || fileType == 'vob' || fileType == 'mpeg' || fileType == 'wmv' || fileType == 'mpe') {
        fileType = 'mp4'
    }
    if (fileType == 'zip' || fileType == 'rar' || fileType == '7z' || fileType == 'tar' || fileType == 'cab') {
        fileType = 'zip'
    }
    switch (fileType) {
        case 'iso':
            return 'file-iso';
        case 'mp4':
            return 'file-video';
        case 'txt':
            return 'file-txt';
        case 'jpg':
            return 'file-tupian';
        case 'exe':
            return 'file-exe';
        case "pdf":
            return "file-pdf";
        case "xls":
            return "file-excel";
        case "xlsx":
            return "file-excel";
        case "ppt":
            return "file-ppt";
        case "pptx":
            return "file-ppt";
        case "doc":
            return "file-word";
        case "docx":
            return "file-word";
        case "zip":
            return "file-zip";
        default:
            return "file-unknown";
    }
}

export const genBreadList = (json) => {
    debugger
    const breads = [];
    const ids = json.idPath.split('/');
    const names = json.filePath.split('/');
    names.forEach((element, index) => {
        if (!!element) {
            breads.push({
                title: element,
                value: ids[index]
            })
        }
    });
    return breads
}

export const gencurBreadList = (json) => {
    const breads = [];
    const ids = json.idPath.split('/');
    const names = json.filePath.split('/');
    ids.splice(ids.length - 1, 1);
    names.splice(names.length - 1, 1);
    names.forEach((element, index) => {
        if (!!element) {
            breads.push({
                title: element,
                value: ids[index]
            })
        }
    });
    return breads
}
export const getCurPath = (path) => {
    const names = path.split('/');
    return names[names.length - 2]
}

export const getCurId = (idPath) => {
    const ids = idPath.split('/');
    return ids[ids.length - 2]
}

// 图片预览
export const ImagePreviewListener = (event, $vm) => {
    // vShowContent
    event = event ? event : window.event;
    let ele = event.srcElement ? event.srcElement : event.target;
    if (ele.tagName === 'IMG') {
        if ($vm.imageClick != null) {
            // 覆盖图片点击事件
            $vm.imageClick(ele);
        } else {
            if (ele.src.indexOf('/eco/preview') > -1) {
                $vm.preview_imgsrc = ele.src + "_l";
            } else {
                $vm.preview_imgsrc = ele.src;
            }
        }
    }
}